// extracted by mini-css-extract-plugin
module.exports = {"scroll-button":"scroll-to-top_scroll-button__2V0ar"};